import React, { Component } from "react";
import HeaderMenu from '../Components/HeaderMenu'
import Slider from './slider'
import ImgSection from './ImgSection'
import BuyNow from './BuyNow'
import Features from './Features'
import Team from './Team'
import Faqs from '../Components/Faqs/demo'
// import Reward from '../Components/Rewards/index'

import Blogs from './Blogs'
import Footer from '../Components/Footer/Footer'
import Cards from './Cards'
import bkImg from '../img/swap.png'

const Home = () => {
  return (
    <div className="" style={{overflowX:'hidden'}}>
      <div className='pcc---slider-v2'>
      <HeaderMenu />
      <Slider />
      </div>
      {/* <Reward/> */}
      <ImgSection />
      
      {/* <Cards/> */}
      <Features />
      <BuyNow />
      
      
      {/* <Blogs /> */}
      <Team />
      <Faqs/>
      <Footer />
    </div>
  );
}

export default Home;
